// extracted by mini-css-extract-plugin
module.exports = {"viewports":"\"../../../../viewports.css\"","desktop":"1024px","realtime-members":"realtime-members_realtime-members__HxFux","edit-message":"realtime-members_edit-message__1zNS2"};